import * as angular from "angular";


function uploadFile(Upload, IamRequests) {
  return function (file) {
    return Upload.upload(IamRequests.uploadFile(file));
  }
}

angular
  .module('bringoz.admin.commons')
  .service('uploadFile', uploadFile);
